/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_ConnectingInputs */

const th_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังเชื่อมต่อ`)
};

const en_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting`)
};

const ja_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続中`)
};

const zh_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在连接`)
};

const es_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando`)
};

const pt_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando`)
};

const id_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghubungkan`)
};

const fr_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion`)
};

const tl_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kumokonekta`)
};

const vi_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kết nối`)
};

const ko_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결 중`)
};

const de_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung wird aufgebaut`)
};

const ru_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключение`)
};

const tr_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlanıyor`)
};

const it_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connessione`)
};

const pl_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączenie`)
};

const uk_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підключення`)
};

const hi_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़ा जा रहा है`)
};

const ar_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الاتصال`)
};

const ms_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang menyambung`)
};

const bn_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যুক্ত হচ্ছে`)
};

const zh_tw2_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連線中`)
};

const zh_hk2_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連線中`)
};

const ur_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جڑ رہا ہے`)
};

const fa_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال اتصال`)
};

const sw_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaunganisha`)
};

const nl_video_connecting = /** @type {(inputs: Video_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met verbinden`)
};

/**
* | output |
* | --- |
* | "Connecting" |
*
* @param {Video_ConnectingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_connecting = /** @type {((inputs?: Video_ConnectingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_ConnectingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_connecting(inputs)
	if (locale === "ja") return ja_video_connecting(inputs)
	if (locale === "zh") return zh_video_connecting(inputs)
	if (locale === "es") return es_video_connecting(inputs)
	if (locale === "pt") return pt_video_connecting(inputs)
	if (locale === "id") return id_video_connecting(inputs)
	if (locale === "fr") return fr_video_connecting(inputs)
	if (locale === "tl") return tl_video_connecting(inputs)
	if (locale === "vi") return vi_video_connecting(inputs)
	if (locale === "ko") return ko_video_connecting(inputs)
	if (locale === "de") return de_video_connecting(inputs)
	if (locale === "ru") return ru_video_connecting(inputs)
	if (locale === "tr") return tr_video_connecting(inputs)
	if (locale === "it") return it_video_connecting(inputs)
	if (locale === "pl") return pl_video_connecting(inputs)
	if (locale === "uk") return uk_video_connecting(inputs)
	if (locale === "hi") return hi_video_connecting(inputs)
	if (locale === "ar") return ar_video_connecting(inputs)
	if (locale === "ms") return ms_video_connecting(inputs)
	if (locale === "bn") return bn_video_connecting(inputs)
	if (locale === "zh-TW") return zh_tw2_video_connecting(inputs)
	if (locale === "zh-HK") return zh_hk2_video_connecting(inputs)
	if (locale === "ur") return ur_video_connecting(inputs)
	if (locale === "fa") return fa_video_connecting(inputs)
	if (locale === "sw") return sw_video_connecting(inputs)
	if (locale === "nl") return nl_video_connecting(inputs)
	return en_video_connecting(inputs)
});